'use client';

import { jsx, jsxs } from "react/jsx-runtime";
import { memo, useRef } from "react";
import { classNames } from "../../utils/styles/classNames.js";
import { Text } from "../../atoms/Text/Text.js";
import { buttonStatus, buttonCursor, buttonVariant, button, header as header$1, variants } from "../../molecules/Tabs/Tabs.css.js";
import { getTextColor } from "../../molecules/Tabs/utils/getTextColor.js";
import { CustomAnchor } from "../../quarks/CustomAnchor/CustomAnchor.js";
import { tabItem, status, tab, header, navWrapper } from "./MobileTabNav.css.js";
function MobileTabNavComponent({
  tabs,
  variant: variantProp,
  currentTabId
}) {
  const variant = variantProp || "primary";
  const headerRef = useRef(null);
  return /* @__PURE__ */ jsx(
    "nav",
    {
      className: classNames(navWrapper, variants[variant]),
      ref: headerRef,
      children: /* @__PURE__ */ jsx("ul", { className: classNames(header$1, header), children: tabs && tabs.map((tab$1) => {
        const active = !tab$1.disabled && tab$1.id === currentTabId;
        const textColor = getTextColor(active, tab$1.disabled);
        const defaultStatus = active ? "active" : "default";
        const status$1 = tab$1.disabled ? "disabled" : defaultStatus;
        const Icon = tab$1.icon;
        const iconJsx = Icon && /* @__PURE__ */ jsx(Icon, { filled: active, size: "md" });
        const isLink = !!tab$1.href;
        const Element = isLink ? CustomAnchor : "button";
        return /* @__PURE__ */ jsx(
          "li",
          {
            className: classNames(tab, status[status$1]),
            children: /* @__PURE__ */ jsxs(
              Element,
              {
                "aria-current": active ? true : void 0,
                "aria-disabled": !isLink && tab$1.disabled ? true : void 0,
                className: classNames(
                  button,
                  !tab$1.disabled && buttonVariant[variant === "secondary" ? "secondary" : "primary"],
                  buttonCursor[tab$1.disabled ? "disabled" : "default"],
                  buttonStatus[status$1],
                  tabItem
                ),
                href: isLink ? tab$1.href : void 0,
                role: !isLink ? "link" : void 0,
                type: !isLink ? "button" : void 0,
                onClick: !tab$1.disabled ? tab$1.onClick : void 0,
                children: [
                  iconJsx,
                  tab$1.indicator,
                  tab$1.a11yLabel && /* @__PURE__ */ jsx(Text, { visuallyHidden: true, children: tab$1.a11yLabel }),
                  /* @__PURE__ */ jsx(
                    Text,
                    {
                      "aria-hidden": tab$1.a11yLabel ? "true" : void 0,
                      as: "span",
                      color: textColor,
                      variant: "body.sm",
                      children: tab$1.label
                    }
                  )
                ]
              }
            )
          },
          tab$1.id
        );
      }) })
    }
  );
}
const MobileTabNav = /* @__PURE__ */ memo(MobileTabNavComponent);
export {
  MobileTabNav
};
